/* Process stepper (engagement pass §3.4): tablist with roving tabindex, arrow keys, Home/End and drag-snap.
 * Sets .is-active / .is-done on the tabs (the CSS fills the route), shows one panel and one scene. */

function initStepper(root) {
  const tabs = Array.from(root.querySelectorAll('[role="tab"][data-mk-step]'));
  const panels = Array.from(root.querySelectorAll('[data-mk-step-panel]'));
  const scenes = Array.from(root.querySelectorAll('[data-mk-step-scene]'));
  if (tabs.length < 2) return;
  const rtl = getComputedStyle(root).direction === 'rtl';
  const tablist = root.querySelector('[role="tablist"]');
  let active = Math.max(0, tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));

  const horizontal = () => window.matchMedia('(min-width: 1024px)').matches;

  const render = (focus) => {
    tabs.forEach((tab, i) => {
      const isActive = i === active;
      tab.classList.toggle('is-active', isActive);
      tab.classList.toggle('is-done', i < active);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
      if (isActive && focus) tab.focus({ preventScroll: true });
    });
    panels.forEach((p, i) => { p.hidden = i !== active; });
    scenes.forEach((s, i) => { s.hidden = i !== active; });
    root.style.setProperty('--step', String(active));
    if (tablist) tablist.setAttribute('aria-orientation', horizontal() ? 'horizontal' : 'vertical');
  };

  const set = (i, focus) => {
    const n = Math.min(tabs.length - 1, Math.max(0, i));
    if (n === active && !focus) return;
    active = n;
    render(focus);
  };

  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => set(i, false));
    tab.addEventListener('keydown', (e) => {
      const h = horizontal();
      let next = null;
      if ((h && e.key === (rtl ? 'ArrowLeft' : 'ArrowRight')) || e.key === 'ArrowDown') next = active + 1;
      else if ((h && e.key === (rtl ? 'ArrowRight' : 'ArrowLeft')) || e.key === 'ArrowUp') next = active - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      if (next === null) return;
      e.preventDefault();
      set((next + tabs.length) % tabs.length, true);
    });
  });

  // Drag-snap (horizontal stepper only): move the pointer along the rail and the nearest stop becomes active.
  if (tablist && window.PointerEvent) {
    let dragging = false;
    let start = null;
    const nearest = (x, y) => {
      const h = horizontal();
      let best = 0;
      let dist = Infinity;
      tabs.forEach((tab, i) => {
        const node = tab.querySelector('.mk-stepper__node') || tab;
        const r = node.getBoundingClientRect();
        const c = h ? r.left + r.width / 2 : r.top + r.height / 2;
        const d = Math.abs((h ? x : y) - c);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    };
    tablist.addEventListener('pointerdown', (e) => {
      if (!horizontal()) return; // vertical stepper: tap and keys only, page scrolling is never blocked
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      start = { x: e.clientX, y: e.clientY, id: e.pointerId };
      dragging = false;
    });
    tablist.addEventListener('pointermove', (e) => {
      if (!start) return;
      // A drag starts after 8px of travel; a plain tap/click is left to the tab's click handler.
      if (!dragging && Math.hypot(e.clientX - start.x, e.clientY - start.y) < 8) return;
      if (!dragging) {
        dragging = true;
        try { tablist.setPointerCapture(start.id); } catch (_) { /* not capturable */ }
      }
      set(nearest(e.clientX, e.clientY), false);
    });
    const end = (e) => {
      if (dragging) {
        set(nearest(e.clientX, e.clientY), false);
        try { tablist.releasePointerCapture(e.pointerId); } catch (_) { /* already released */ }
      }
      dragging = false;
      start = null;
    };
    tablist.addEventListener('pointerup', end);
    tablist.addEventListener('pointercancel', end);
  }

  window.matchMedia('(min-width: 1024px)').addEventListener('change', () => render(false));
  render(false);
}

document.querySelectorAll('[data-mk-stepper]').forEach(initStepper);
